import { render } from "./publicComp.vue?vue&type=template&id=2dd5c6a0"
import script from "./publicComp.vue?vue&type=script&lang=js"
export * from "./publicComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__